// Questions people actually ask before they write to me, answered in the first
// sentence. Answer engines quote the first sentence, so each answer leads with
// the answer and explains afterwards.
//
// These are mirrored as FAQPage structured data in frontend/public/index.html,
// and scripts/check-faq.mjs fails the build if the two drift apart.

export const faq = [
  {
    q: 'What does Brandon Crenshaw build?',
    a: 'AI products and the agents behind them: LLM gateways, voice agents, retrieval systems, and the pipelines that run a business around them. Eleven products are live and linked on the work page, with case studies covering how the hardest ones were built.',
  },
  {
    q: 'What does it cost to work with him?',
    a: 'Project work starts at $5,000 a month for a single seat covering product, engineering and go to market. Shorter advisory engagements are priced per engagement. Pricing is on the site rather than behind a call.',
  },
  {
    q: 'Is he available for a full time role?',
    a: 'Yes. He is open to senior and founding AI engineer roles, remote or hybrid in Chicago, and would relocate to San Francisco for the right one. The contact form has an option for exactly that.',
  },
  {
    q: 'What is his stack?',
    a: 'TypeScript and Python across the products, React and Expo on the front end, Postgres and Supabase for data, and Claude, Gemini and OpenAI behind a gateway that reports the cost of every call. Infrastructure runs on Vercel, Railway and Google Cloud.',
  },
  {
    q: 'How does he keep AI systems from making things up?',
    a: 'Scoring and decisions run in code, and the model only explains what the code computed. Every number on a page traces to a source, citations are checked against the evidence the model was given, and anything a model proposes that costs money needs a person to confirm it.',
  },
  {
    q: 'How fast can something ship?',
    a: 'A working prototype in one to two weeks, and a production system with tests, monitoring and a rollback path in four to eight. Eleven shipped products and a public record of what each one does and does not prove is the evidence for that pace.',
  },
];

export default faq;
